import { render, staticRenderFns } from "./SpeechToText.vue?vue&type=template&id=92d7b9e0&scoped=true"
import script from "./SpeechToText.vue?vue&type=script&lang=js"
export * from "./SpeechToText.vue?vue&type=script&lang=js"
import style0 from "./SpeechToText.vue?vue&type=style&index=0&id=92d7b9e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d7b9e0",
  null
  
)

export default component.exports